var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlomberie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_573_4117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.9877 19.7742H25.9913C20.4702 19.7742 15.9944 24.25 15.9944 29.7711V29.7711",
    stroke: "#A3AED0",
    strokeWidth: 9.99695
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9902 11.7765V17.7747",
    stroke: "#A3AED0",
    strokeWidth: 5.99817
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9902 11.7766V9.77722",
    stroke: "#A3AED0",
    strokeWidth: 1.99939
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9889 6.71508C33.9889 8.88876 32.2268 10.6509 30.0531 10.6509C27.8794 10.6509 26.1173 8.88876 26.1173 6.71508C26.1173 4.54141 27.8794 2.7793 30.0531 2.7793C32.2268 2.7793 33.9889 4.54141 33.9889 6.71508Z",
    fill: "#A3AED0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9933 6.77808H39.9872",
    stroke: "#A3AED0",
    strokeWidth: 2.99908,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9865 12.7764V26.7721",
    stroke: "#A3AED0",
    strokeWidth: 3.99878,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99634 31.7704L21.9927 31.7704",
    stroke: "#A3AED0",
    strokeWidth: 3.99878,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_573_4117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1381 42.5671C13.1381 43.3626 13.439 44.1254 13.9747 44.6878C14.5104 45.2503 15.2369 45.5662 15.9944 45.5662C16.7519 45.5662 17.4784 45.2503 18.0141 44.6878C18.5497 44.1254 18.8507 43.3626 18.8507 42.5671C18.8507 41.5319 17.9024 39.5495 15.9944 36.7771C14.0864 39.5495 13.1381 41.5319 13.1381 42.5671ZM15.9944 34.7695C18.6604 38.4224 19.9932 41.0214 19.9932 42.5671C19.9932 43.6807 19.5719 44.7487 18.8219 45.5361C18.072 46.3235 17.0549 46.7659 15.9944 46.7659C14.9338 46.7659 13.9167 46.3235 13.1668 45.5361C12.4169 44.7487 11.9956 43.6807 11.9956 42.5671C11.9956 41.0214 13.3283 38.4224 15.9944 34.7695Z",
    fill: "#A3AED0"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_573_4117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9944 48.1344C14.5837 48.1344 13.3426 47.643 12.2709 46.6602C11.1988 45.6769 10.6627 44.3467 10.6627 42.6694C10.6627 41.6142 11.0626 40.4701 11.8624 39.2371C12.6621 38.0042 13.8728 36.6712 15.4946 35.2383C15.5612 35.1828 15.639 35.1384 15.7278 35.105C15.8167 35.0717 15.9056 35.0551 15.9944 35.0551C16.0833 35.0551 16.1721 35.0717 16.261 35.105C16.3499 35.1384 16.4276 35.1828 16.4943 35.2383C18.116 36.6712 19.3267 38.0042 20.1265 39.2371C20.9263 40.4701 21.3261 41.6142 21.3261 42.6694C21.3261 44.3467 20.7901 45.6769 19.718 46.6602C18.6463 47.643 17.4051 48.1344 15.9944 48.1344ZM16.1777 46.135C16.311 46.1239 16.425 46.0712 16.5196 45.977C16.6138 45.8824 16.6609 45.7684 16.6609 45.6352C16.6609 45.4796 16.6109 45.3548 16.5109 45.2606C16.411 45.166 16.2832 45.1242 16.1277 45.1353C15.6723 45.1686 15.1891 45.0438 14.6782 44.7608C14.1672 44.4773 13.8451 43.9634 13.7118 43.2192C13.6896 43.097 13.6311 42.9971 13.5365 42.9193C13.4423 42.8416 13.3341 42.8027 13.2119 42.8027C13.0564 42.8027 12.9287 42.8609 12.8287 42.9773C12.7288 43.0942 12.6954 43.2303 12.7288 43.3858C12.9176 44.3966 13.3619 45.1186 14.0617 45.5518C14.7615 45.985 15.4668 46.1794 16.1777 46.135V46.135Z",
    fill: "#A3AED0"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_573_4117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(-0.000610352 0.779907)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_573_4117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9951,
    height: 15.9951,
    fill: "white",
    transform: "translate(7.99683 32.7701)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_573_4117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9951,
    height: 15.9951,
    fill: "white",
    transform: "translate(7.99683 32.7701)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlomberie);
export default __webpack_public_path__ + "static/media/Plomberie.8fd7a93c737d580a64bc961080b68e75.svg";
export { ForwardRef as ReactComponent };